module.exports = __webpack_public_path__ + "img/tick.0f71c3d2.svg";